import React, { FC, useEffect } from 'react';
import './BingoPage.scss';

import { ItvGenericPage } from '../ItvGenericPage';
import { useUserContext } from '../../../providers/UserProvider';
import { BRANDS } from '../../../components/Itv/types';
import { useFirstSubNavItem } from '../shared/useFirstSubNavItem';

export const BingoPage: FC = () => {
  const { setTheme } = useUserContext();
  const effectiveSubpage = useFirstSubNavItem('bingo');

  useEffect(() => {
    setTheme(BRANDS.BINGO);
  }, [setTheme]);

  return <ItvGenericPage variant="bingo" subpage={effectiveSubpage} />;
};
